import Moment from "moment";
import "../../../../assets/stylesheets/ConfidentialApplication/ConfProfessionalDesignations.scss";

export default function ConfProfessionalDesignations({
                                                         designations = [],
                                                         form_id
                                                     }) {
    const labelColumnClass =
        form_id === "confidential_education" ? "col-5" : "col-6";

    if (designations.length === 0) {
        return (
            <div className="row">
                <div className={labelColumnClass}>
                    <strong id="eduHighestLevelLabel">Professional Designations*</strong>
                </div>
                <div className="col-6 bo--text-color">
                    <p>None</p>
                </div>
            </div>
        );
    }

    return (
        <div className="row">
            <div className={labelColumnClass}>
                <strong id="eduHighestLevelLabel">Professional Designations*</strong>
            </div>
            <div className="col-6 bo--text-color">
                {designations.map((designation, index) => (
                    <div className="prof-designations__entry" key={designation.id || index}>
                        <span className="prof-designations__name">
                            {designation.designationdescription}
                        </span>
                        <span className="prof-designations__date">
                            Issue Date: {Moment.utc(designation.dateacquired).format(
                            "MM/DD/YYYY"
                        )}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}

